import * as React from 'react';
import '../style/actionImageCard.css';
import '../style/utils.css';
import { useResources, useComponentResources } from '../store/resourcesProvider';

interface ActionImageCardProps {
  imageUrl?: string | null;
  title: string;
  onAction?: () => void;
  actionLabel?: string;
}

const ActionImageCard: React.FC<ActionImageCardProps> = ({
  imageUrl,
  title,
  onAction,
  actionLabel,
}) => {
  const resources = useResources();
  // preload & read component-scoped resources for action image card (includes userId automatically)
  const pageRes = useComponentResources('ActionImageCard', ['Action.MoreInfo', 'Action.MissingImage']);
  const [missing, setMissing] = React.useState(false);

  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const img = e.currentTarget as HTMLImageElement;
    img.onerror = null;
    setMissing(true);
    img.classList.add('img-missing');
  };

  const label = actionLabel || (pageRes['Action.MoreInfo'] ?? resources.get('Action.MoreInfo', 'מידע נוסף'));

  return (
    <div className="action-image-card">
      {imageUrl ? (
        <img src={imageUrl} alt={title} loading="lazy" onError={handleError} />
      ) : null}
      {missing || !imageUrl ? (
        <div className="card-missing-overlay" aria-hidden>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 5v6.586l-2-2V7H7v10h6.586l-2 2H5V5h16z" fill="rgba(255,255,255,0.9)" />
          </svg>
          <div className="missing-text">{pageRes['Action.MissingImage'] ?? resources.get('Action.MissingImage', 'תמונה אינה זמינה')}</div>
        </div>
      ) : null}
      <div className="card-body">
        <h3>{title}</h3>
        {onAction && (
          <button className="btn btn-primary mt-8" onClick={onAction}>{label}</button>
        )}
      </div>
    </div>
  );
};

export default ActionImageCard;